/** Normalize adminStatus / status strings for comparison */
export function normalizeOrderStatusKey(value: unknown): string {
  if (value == null) return "";
  return String(value).trim().toLowerCase().replace(/[\s_-]+/g, "");
}

export function isReadyForApproval(order: {
  adminStatus?: unknown;
}): boolean {
  const key = normalizeOrderStatusKey(order.adminStatus);
  return key === "readyforapproval";
}

export function canApproveOrder(order: {
  status?: string;
  adminStatus?: unknown;
}): boolean {
  return order.status === "pending" || isReadyForApproval(order);
}

export function getOrderDisplayStatus(order: {
  status?: string;
  adminStatus?: unknown;
}): { label: string; styleKey: string } {
  if (isReadyForApproval(order)) {
    return { label: "Ready for Approval", styleKey: "readyForApproval" };
  }
  const status = order.status ?? "";
  const label = status === "cancel" ? "Canceled" : status;
  return { label, styleKey: status };
}

export function orderStatusPillClass(styleKey: string): string {
  switch (styleKey) {
    case "readyForApproval":
      return "bg-amber-100 text-amber-800";
    case "approved":
      return "bg-green-100 text-green-700";
    case "pending":
      return "bg-yellow-100 text-yellow-700";
    case "delivered":
      return "bg-blue-100 text-blue-700";
    case "cancel":
      return "bg-red-100 text-red-700";
    case "rider":
      return "bg-purple-100 text-purple-700";
    default:
      return "bg-gray-100 text-gray-700";
  }
}
